import React, { useEffect, useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

import createRegCss from "../../css/createregister.module.css";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import InputGroup from "../../elements/InputGroup";
import Loader2 from "../../elements/Loader2";
import Dropdown from "../../elements/Dropdown";
import { useHistory, useParams } from "react-router";
import { createInvestmentRegisterApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";

const CreateInvestmentRegister = (props) => {
  let companyOptions = props.companyOptions;
  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [regName, setRegName] = useState(null);
  const [company, setCompany] = useState(null);
  const [asOnDate, setAsOnDate] = useState(null);

  useEffect(() => {
    console.log("company", company);
  }, [company]);
  const createRegister = () => {
    const payload = {
      // name: regName,
      // companyID: company.value,

      InvestRegister: regName,
      ParentCompany: company.value,
      investment_date: "",
      investment_value: "",
      shares_bought: "",
      total_no_shares: "",
      holding: "",
      non_controlling_interest: "",
      nature_of_relationship: "",
      investment_company_id: "",
      investment_company_code: "",
    };
    setLoader(true);

    createInvestmentRegisterApiHandler(payload)
      .then((response) => {
        console.log("Response:", response.data);
        let register = response?.data?.investmentRegister;
        setLoader(false);
        if (register?._id) {
          history.push(`/detailsIR/${register?._id}`);
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable Create Investment Register",
          "error"
        );
        setLoader(false);
      });
  };
  return (
    <>
      {loader && <Loader2 />}
      <div className={createRegCss.alignForm}>
        <div className={createRegCss.container2}>
          <div className={`${commoncss.dFlex} mb-3`}>
            <div
              className={commoncss.dFlexClm}
              style={{ alignItems: "center" }}
            >
              <span className={createRegCss.heading1}>
                Create Investment Register
              </span>
              <span className={createRegCss.label1}>
                Lorem ipsum dolor sit amet consec
              </span>
            </div>
          </div>
          <div className={`${createRegCss.container3} mt-3 mb-1`}>
            <InputGroup
              label="Name of Investment Register"
              inputs={[
                <>
                  <input
                    name="invreg_name"
                    placeholder="Investment register"
                    type="text"
                    value={regName}
                    onChange={(e) => setRegName(e.target.value)}
                  />
                </>,
              ]}
            />

            <InputGroup
              label="Company name"
              class_="mt-2"
              inputs={[
                <>
                  {companyOptions.length > 0 && (
                    <Dropdown
                      //   label="Select Company"
                      value={company}
                      options={companyOptions}
                      onSelect={(opt) => setCompany(opt)}
                      placeHolder={"Select Company"}
                    />
                  )}
                </>,
              ]}
            />

            <div
              className="mt-4"
              style={{ width: "70%", placeSelf: "center" }}
              onClick={createRegister}
            >
              <button
                type="submit"
                className={buttoncss.primary}
                style={{
                  padding: "7px",
                  width: "100%",
                  "border-radius": "12px",
                }}
              >
                Create Investment Register
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateInvestmentRegister;
